import { useState, useRef } from "react";
import {
  Box,
  Flex,
  Button,
  Text,
  useToast,
  Spinner,
  Center,
} from "@chakra-ui/react";
import { exportConsigConsolidatedReport, uploadConsigTaxNoteExcel } from "@/services/consignado/financial-service/taxNote.service";

interface TaxNoteTabProps {
  backgroundStyle: any;
}

export default function ConsigTaxNoteTab({ backgroundStyle }: TaxNoteTabProps) {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isInternalLoading, setIsInternalLoading] = useState(false); // State para o novo botão
  const toast = useToast();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
    }
  };

  const handleUploadExcel = async () => {
    if (!selectedFile) {
      toast({
        title: "Selecione um arquivo",
        description: "Por favor, selecione um arquivo Excel para enviar",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
      return;
    }
    setIsLoading(true);
    try {
      await uploadConsigTaxNoteExcel(selectedFile);
      toast({
        title: "Sucesso",
        description: "Os emails foram enviados com sucesso",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (error: any) {
      toast({
        title: "Erro ao enviar emails",
        description: `${error}`,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendInternalEmails = async () => {
    if (!selectedFile) {
      toast({
        title: "Selecione um arquivo",
        description: "Por favor, selecione um arquivo Excel para enviar",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
      return;
    }
    setIsInternalLoading(true);
    try {
      await exportConsigConsolidatedReport(selectedFile); // Função que você vai criar no service
      toast({
        title: "Sucesso",
        description: "Os e-mails internos foram enviados com sucesso",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (error: any) {
      toast({
        title: "Erro ao enviar e-mails internos",
        description: `${error}`,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsInternalLoading(false);
    }
  };

  return (
    <Box width="100%" position="relative">
      {(isLoading || isInternalLoading) && (
        <Center
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          bg="rgba(0, 0, 0, 0.1)"
          zIndex={10}
        >
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="green.500"
            size="xl"
          />
        </Center>
      )}
      <Box
        {...backgroundStyle}
        borderRadius="xl"
        p={{ base: 4, md: 6 }}
        color="white"
        boxShadow="lg"
        width="100%"
        mb={2}
      >
        <Text fontSize="xl" fontWeight="bold" fontFamily="Lexend Deca" mb={4}>
          EMAIL DE NOTAS FISCAIS
        </Text>
        <Flex gap={4} justifyContent="space-between" flexWrap="wrap">
          <Button
            color="white"
            colorScheme="green"
            onClick={() => fileInputRef.current?.click()}
          >
            {selectedFile ? "Alterar Arquivo" : "Selecionar Arquivo"}
          </Button>
          {selectedFile && <Text alignSelf="center">{selectedFile.name}</Text>}
          
          {/* Novo botão para envio dos e-mails internos */}
          <Button
            color="white"
            colorScheme="green"
            onClick={handleSendInternalEmails}
            isLoading={isInternalLoading}
          >
            Enviar E-mails Interno
          </Button>
          <Button
            color="white"
            colorScheme="green"
            onClick={handleUploadExcel}
            isLoading={isLoading}
          >
            Enviar E-mails Externos (Parceiro)
          </Button>
        </Flex>
      </Box>
      <input
        type="file"
        accept=".xlsx, .xls"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileSelect}
      />
    </Box>
  );
}
